import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { AppContext } from 'src/components/app-context';
import { filterCategories } from 'src/areas/landing-page/filter-categories';
import type { Product, TrendingProductsQuery } from 'src/types';
import { TRENDING_PRODUCT_CLICK } from 'src/globals/helpers/navigation-action';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { ProductsSection } from '../products-section';
import { productNavigation } from 'src/areas/product/actions/product';
import query from './query.graphql';
import { useGqlQuery } from 'src/hooks/use-gql-query';

type Props = {
  negativeMargin?: boolean;
};

const TrendingProducts: React.FC<Props> = props => {
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();

  const result = useGqlQuery<TrendingProductsQuery>({
    query,
    queryKey: ['trendingProducts'],
  });

  const trendingProducts = result.data?.trendingProducts?.trendingProducts;

  if (
    !(trendingProducts && trendingProducts.nodes) ||
    !trendingProducts.nodes.length
  ) {
    return null;
  }

  const trendingProductsItems = filterCategories(
    trendingProducts.nodes as Product[]
  );

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.TRENDING_PRODUCTS_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    dispatch(productNavigation(TRENDING_PRODUCT_CLICK, data.index + 1));
    trackInternalNavigationClick({
      scope: InternalNavigationScope.TRENDING_PRODUCTS_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ProductsSection
      products={trendingProductsItems}
      title={t('landing', 'trending-products.title')}
      shouldLazyLoadImages
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
      negativeMargin={props.negativeMargin}
    />
  );
};

export default TrendingProducts;
